import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import AppContext from 'context/Context';
import { childrenComponent2Object } from 'function/convert';
import valueFrom from 'utils/valueFrom';

/**
 * 공통 모달
 */
const Common = ({ children, show, className, style, onHide, ...props }) => {
  /* variable */
  const { header, body, footer } = childrenComponent2Object(children);

  /* context */
  const {
    config: { isDark }
  } = useContext(AppContext);

  /* view */
  return (
    <Modal backdrop="static" centered show={show} onHide={onHide} {...props}>
      <Modal.Header
        closeButton
        closeVariant={valueFrom(classNames({ white: isDark }))}
        className="px-card border-bottom-0"
      >
        <Modal.Title>{header}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={className?.body} style={style}>
        {body}
      </Modal.Body>
      <Modal.Footer
        className={classNames('px-card', 'border-top-0', className?.footer)}
      >
        {footer}
      </Modal.Footer>
    </Modal>
  );
};

Common.propTypes = {
  // 표시 여부
  show: PropTypes.bool,

  // 클래스 이름
  className: PropTypes.shape({
    // 내용
    body: PropTypes.string,

    // 하단
    footer: PropTypes.string
  }),

  // 스타일
  style: PropTypes.object,

  // 모달을 숨긴 경우 이벤트
  onHide: PropTypes.func
};
Common.defaultProps = { show: false };

export default Common;
